
import Vue from "vue";
import bgProgressItem from "./progress-item/bg-progress-item.vue";
export default Vue.extend({
  name: "bg-progress",

  components: {
    bgProgressItem,
  },

  /**
   * step - 第几个节点
   * progress_list - 节点列表
   */
  props: {
    step: {
      type: [String, Number],
      default: 0,
    },

    progress_list: {
      type: Array,
      default() {
        return [
          {
            text: "填写信息",
            status: 2,
          },
          {
            text: "邮箱验证",
            status: 2,
          },
          {
            text: "入驻审核",
            status: 2,
          },
          {
            text: "下发账号",
            status: 2,
          },
        ];
      },
    },
  },

  /**
   * initStatus - 初始化节点列表状态
   */
  methods: {
    initStatus() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.progress_list.forEach((item: any, i) => {
        this.$set(
          item,
          "status",
          i === +this.step ? 1 : i < +this.step ? 0 : 2
        );
      });
    },
  },

  mounted() {
    this.initStatus();
  },

  watch: {
    step() {
      this.initStatus();
    },
  },
});
